// extracted by mini-css-extract-plugin
export var active = "_bn-2";
export var highlight = "_bn-1";
export var highlightLayer = "_bn-0";
export var issuePopover = "_bn-3";
export var statusIcon = "_bn-4";